import { createAction, props } from '@ngrx/store';
import { EntityType } from '@planone/bau365/util-fair-data';

import { UserHistoryEntry } from './history.models';

export const loadUserHistory = createAction('[User/History/API] Load all user history entries');
export const loadUserHistorySuccess = createAction(
  '[User/History/API] Load all user history entries success',
  props<{ entries: UserHistoryEntry[] }>()
);
export const loadUserHistoryFailure = createAction(
  '[User/History/API] Load all user history entries failure',
  props<{ error: string }>()
);

export const addToHistory = createAction(
  '[User/History/API] Add visited page to history',
  props<{ fairId: string; entityType: EntityType; id: string }>()
);
export const addToHistorySuccess = createAction(
  '[User/History/API] Add visited page to history success',
  props<{ entry: UserHistoryEntry }>()
);
export const addToHistoryFailure = createAction(
  '[User/History/API] Add visited page to history failure',
  props<{ error: string }>()
);
